<ion-header [translucent]="true">
  <ion-toolbar color="success">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>{{ titulo }}</ion-title>
<!--    <ion-icon (click)="menuDireito()" slot="end" name="ellipsis-vertical-outline"></ion-icon>-->
  </ion-toolbar>

</ion-header>
<!--<ion-menu side="end" contentId="main-content" type="overlay">-->
<!--&lt;!&ndash;  <ion-content>&ndash;&gt;-->
<!--    <ion-list>-->
<!--      <ion-list-header>Fauna</ion-list-header>-->
<!--      <ion-item lines="none">-->
<!--        <div class="unread-indicator-wrapper" slot="start">-->
<!--          <img height="32" [src]="token?.picture" alt="imagem"/>-->
<!--        </div>-->
<!--        <ion-label>-->
<!--          <ion-text>{{token?.nickname}}</ion-text><br/>-->
<!--          <ion-note color="medium" class="ion-text-wrap">-->
<!--           {{ agencia }}-->
<!--          </ion-note>-->
<!--        </ion-label>-->
<!--        <ion-icon slot="end" name="log-out"/>-->
<!--      </ion-item>-->

<!--&lt;!&ndash;      <ion-menu-toggle (click)="logout()" auto-hide="false">&ndash;&gt;-->
<!--        <ion-item (click)="logout()">-->
<!--          <ion-label (click)="logout()">Sairs </ion-label>-->
<!--          <ion-icon (click)="logout()" slot="start" name="log-out"/>-->
<!--        </ion-item>-->
<!--&lt;!&ndash;      </ion-menu-toggle>&ndash;&gt;-->

<!--      <ion-menu-toggle auto-hide="false">-->
<!--        <ion-item>-->
<!--          <ion-label>Sincronizar</ion-label>-->
<!--          <ion-icon slot="start" name="sync"/>-->
<!--        </ion-item>-->
<!--      </ion-menu-toggle>-->

<!--&lt;!&ndash;      <ion-item>&ndash;&gt;-->
<!--&lt;!&ndash;        <ion-icon slot="start" name="sync"/>&ndash;&gt;-->
<!--&lt;!&ndash;        <ion-label>Sincronizar</ion-label>&ndash;&gt;-->
<!--&lt;!&ndash;      </ion-item>&ndash;&gt;-->
<!--    </ion-list>-->
<!--    &lt;!&ndash;  <ion-card>&ndash;&gt;-->
<!--    &lt;!&ndash;    <ion-card-header>&ndash;&gt;-->

<!--    &lt;!&ndash;    </ion-card-header>&ndash;&gt;-->
<!--    &lt;!&ndash;    <ion-card-content>&ndash;&gt;-->
<!--    &lt;!&ndash;      <ion-list>&ndash;&gt;-->
<!--    &lt;!&ndash;        <ion-item>&ndash;&gt;-->
<!--    &lt;!&ndash;          <img height="64" [src]="token?.picture"  alt="imagem"/>&ndash;&gt;-->
<!--    &lt;!&ndash;          <ion-label>{{token?.nickname}}</ion-label>&ndash;&gt;-->
<!--    &lt;!&ndash;          <ion-icon slot="end" name="log-out"/>&ndash;&gt;-->
<!--    &lt;!&ndash;        </ion-item>&ndash;&gt;-->
<!--    &lt;!&ndash;        <ion-item>&ndash;&gt;-->
<!--    &lt;!&ndash;          <ion-icon slot="start" name="sync"/>&ndash;&gt;-->
<!--    &lt;!&ndash;          <ion-title>Sincronizar</ion-title>&ndash;&gt;-->
<!--    &lt;!&ndash;        </ion-item>&ndash;&gt;-->
<!--    &lt;!&ndash;      </ion-list>&ndash;&gt;-->
<!--    &lt;!&ndash;    </ion-card-content>&ndash;&gt;-->
<!--    &lt;!&ndash;  </ion-card>&ndash;&gt;-->
<!--&lt;!&ndash;  </ion-content>&ndash;&gt;-->
<!--</ion-menu>-->
